<script setup lang="ts">
import {defineProps, onMounted, ref, watch} from "vue";

export interface Props {
    titles: string[],
}

const emit = defineEmits<{
    (e: 'changed', columns: string[][]): void
}>()

const props = defineProps<Props>();
const rows = ref([])

const changeTable = (value, i, j) => {
    rows.value[i][j] = value;
    emit('changed', rows.value.slice(0, -1))

    cleanUpEmptyRows()
    if (!isEmptyRow(rows.value[rows.value.length-1])) {
        addEmptyLine()
    }
}

const isEmptyRow = (row) => {
    return row.every(cell => cell === '');
};

const cleanUpEmptyRows = () => {
    rows.value = rows.value.filter((row, index) => !isEmptyRow(row) || index === rows.value.length - 1);
};

const addEmptyLine = () => {
    const row = []
    props.titles.forEach(() => {
        row.push('')
    })

    rows.value.push(row)
}

onMounted(() => {
    addEmptyLine()
})

watch(rows, () => {
    emit('changed', rows.value.slice(0, -1))
}, { deep: true })

</script>

<template>
    <div class="px-4 sm:px-6 lg:px-8">
        <div class="mt-8 flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <table class="min-w-full divide-y divide-gray-300">
                        <thead>
                        <tr class="divide-x divide-gray-200">
                            <th scope="col"
                                class="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0">Номер
                            </th>
                            <th scope="col" class="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
                                v-for="title in props.titles">
                                {{ title }}
                            </th>
                        </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 bg-white">
                        <tr v-for="(row, i) in rows" class="divide-x divide-gray-200">
                            <td class="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-0">
                                {{ i + 1 }}
                            </td>
                            <td class="whitespace-nowrap text-sm text-gray-500" v-for="(title, j) in row">
                                <input class="border-transparent focus:border-transparent focus:ring-0 w-full" type="text" :value="title" @input="(event)=>changeTable(event.target.value, i, j)">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>